<mat-form-field [floatLabel]="myFloatLabel && myFloatLabel !== 'never' ? myFloatLabel : 'auto'">
  <mat-label>{{ placeholder }} </mat-label>

  <input
    #searchInput
    type="text"
    matInput
    [placeholder]="placeholder"
    [formControl]="filterControl"
    [matAutocomplete]="auto"
    (ngModelChange)="onInputValueChanged()"
    (input)="onInputChange($event)"
    (focus)="onInputFocus()"
    [autocomplete]="suggestionsOff ? 'new-password' : null"
  />

  <mat-autocomplete
    (closed)="autocompleteOpened = false"
    (opened)="autocompleteOpened = true"
    #auto="matAutocomplete"
    [class]="customClass"
    (optionSelected)="handleOptionSelected($event)"
  >
    @for (option of filteredOptions | async; track option) {
      <mat-option
        class="single-select-search-option"
        [ngClass]="{ wide: wideClass }"
        (onSelectionChange)="changeEmit($event, option); clearInput ? clearSearchInput() : null"
        [value]="option.text"
      >
        <span [innerHTML]="option.text"></span>
        @if (customOption) {
          <span class="add-custom-value">{{ 'global.add_to_the_system' | transloco }}</span>
        }
      </mat-option>
    }
    <div #endOfList></div>
  </mat-autocomplete>
  @if (iconPath) {
    @if (!staticIcon) {
      <span
        class="select-arrow"
        matTextSuffix
        [inlineSVG]="iconPath + (autocompleteOpened ? 'up' : 'down') + '.svg'"
      ></span>
    }
    @if (staticIcon) {
      <span class="custom-icon" [inlineSVG]="iconPath"></span>
    }
  } @else {
    <span
      class="select-arrow"
      matTextSuffix
      [inlineSVG]="'/icons/icon-arrow-' + (autocompleteOpened ? 'up' : 'down') + '.svg'"
    ></span>
  }
</mat-form-field>
